export enum SecurityScope {
  ACCOUNT_VIEW = 'Account_View',
  ACCOUNT_UPDATE = 'Account_Update',
  CARTS_CREATE = 'Carts_Create',
  CARTS_UPDATE = 'Carts_Update',
  CARTS_ADD = 'Carts_Add',
  CARTS_DELETE = 'Carts_Delete',
  CATALOG_VIEW = 'Catalog_View',
  CUSTOMER_VIEW = 'Customer_View',
  CUSTOMER_UPDATE = 'Customer_Update',
  DELIVERY_ADDRESSES_VIEW = 'DeliveryAddresses_View',
  DELIVERY_ADDRESSES_UPDATE = 'DeliveryAddresses_Update',
  EMPLOYEES_VIEW = 'Employees_View',
  EMPLOYEES_UPDATE = 'Employees_Update',
  INVOICES_VIEW = 'Invoices_View',
  ORDER_LISTS_VIEW = 'OrderLists_View',
  ORDER_LISTS_UPDATE = 'OrderLists_Update',
  ORDER_LISTS_LINES_VIEW = 'OrderListsLines_View',
  ORDER_LISTS_LINES_UPDATE = 'OrderListsLines_Update',
  ORDER_LISTS_LINES_ADD = 'OrderListsLines_Add',
  ORDER_LISTS_LINES_DELETE = 'OrderListsLines_Delete',
  ORDERS_VIEW = 'Orders_View',
  SHIPMENTS_VIEW = 'Shipments_View',
  REPORTS_VIEW = 'Reports_View',
  RETURNS_VIEW = 'Returns_View',
  RETURNS_VIEWALL = 'Returns_ViewAll',
  RETURNS_UPDATE = 'Returns_Update',
  // Use this to trigger access denied for testing purposes
  TEST_ACCESS_DENIED = 'Access to pages with this scope is denied'
}

// Helper functions
// TODO: Find a better place for these
export const Can = (scope: SecurityScope) => {
  return function (accessControlList?: SecurityScope): boolean {
    if (!accessControlList) {
      return false;
    }

    return accessControlList.includes(scope);
  };
};
